import createReactComponent from '../createReactComponent';
export default createReactComponent('corner-up-left', 'CornerUpLeft', [["path",{"d":"M5 10.027h10a4 4 0 0 1 4 4V19M9.78 5 5 10.027l4.78 5.028","key":"svg-0"}]]);